import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import WebFont from 'webfontloader';

import lightGallery from 'lightgallery';
import 'lightgallery/css/lightgallery.css';

import Swiper from 'swiper/bundle';
import {Autoplay, Navigation} from 'swiper/modules';

import 'swiper/swiper-bundle.css';
import './styles/main.scss';


document.addEventListener('DOMContentLoaded', function () {


  const introSwiper = new Swiper('.news-swiper', {
    spaceBetween: 10,
    slidesPerView: 1,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
    },
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });


  const filterItems = document.querySelectorAll('.filter-item');
  // Variable to store the current category
  let currentCategory = '';

  // Event listener for clicking on filter items
  filterItems.forEach(function (filterItem) {
    filterItem.addEventListener('click', function () {
      // Get the category from the clicked filter item
      const category = this.dataset.category;

      // Store the current category
      currentCategory = category;

      // Make the AJAX request using the current category
      makeAjaxRequest(category);

    });
  });


  // Function to make the AJAX request
  function makeAjaxRequest(category) {
    const data = new FormData();
    data.append('action', 'filter_posts');
    data.append('category', category);
    data.append('embedded', true); // Include the embedded parameter

    // Construct the AJAX URL
    const ajaxUrl = ajax_object.ajax_url;

    fetch(ajaxUrl, {
      method: 'POST',
      body: data
    })
      .then(response => response.text())
      .then(body => {
        // Parse the HTML response into a DOM element
        const responseElement = document.createElement('div');
        responseElement.innerHTML = body;

        // Select all elements with IDs starting with "custom-"
        const elements = responseElement.querySelectorAll('[id^="custom-"]');

        // Sort the elements based on their IDs
        const sortedElements = Array.from(elements).sort(function (a, b) {
          // Extract the numeric part of the IDs
          const idA = parseInt(a.id.replace('custom-', ''));
          const idB = parseInt(b.id.replace('custom-', ''));

          // Compare the numeric parts
          return idA - idB;
        });

        // Clear the existing content
        const filterSelector = document.querySelector('#filter-selector');
        filterSelector.innerHTML = '';

        // Append the sorted elements to the container
        sortedElements.forEach(function (element) {
          filterSelector.appendChild(element);
        });

        // Reapply the classes to the container
        filterSelector.classList.add('filter');

        // Update the URL with the current filter category
        const url = new URL(window.location.href);
        url.searchParams.set('category', category);
        window.history.pushState({category: category}, '', url.toString());

      })
      .catch(error => {
        console.error('Error:', error);
        // Hide loading animation on error if it exists
        if (loadingAnimation) {
          loadingAnimation.style.display = 'none';
        }
      });

  }

  var mySwiper = new Swiper('.swiper', {
    modules: [Autoplay, Navigation],
    loop: true,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
    on: {
      init: function () {
        var activeSlide = this.slides[this.activeIndex];
        var videoWrapper = activeSlide.querySelector('.embed-container');
        if (videoWrapper) {
          var videoIframe = videoWrapper.querySelector('iframe');
          if (videoIframe && videoIframe.src.includes('vimeo.com')) {
            var src = videoIframe.getAttribute('src');
            src += (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1&muted=1';
            videoIframe.setAttribute('src', src);
          }
        }
      },
      slideChangeTransitionStart: function () {
        pausePreviousVideo(this);
        autoplayVideo(this);
      }
    }
  });

  function autoplayVideo(swiper) {
    var activeSlide = swiper.slides[swiper.activeIndex];
    var videoWrapper = activeSlide.querySelector('.embed-container');
    if (videoWrapper) {
      var videoIframe = videoWrapper.querySelector('iframe');
      if (videoIframe && videoIframe.src.includes('vimeo.com')) {
        var src = videoIframe.getAttribute('src');
        if (!src.includes('autoplay=1')) {
          src += (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1&muted=1';
          videoIframe.setAttribute('src', src);
        }
      }
    }
  }

  function pausePreviousVideo(swiper) {
    var previousSlide = swiper.slides[swiper.previousIndex];
    var videoWrapper = previousSlide.querySelector('.embed-container');
    if (videoWrapper) {
      var videoIframe = videoWrapper.querySelector('iframe');
      if (videoIframe && videoIframe.src.includes('vimeo.com')) {
        var src = videoIframe.getAttribute('src').replace('&autoplay=1', '').replace('?autoplay=1', '');
        videoIframe.setAttribute('src', src);
      }
    }
  }

  // Autoplay the active slide's video on page load
  autoplayVideo(mySwiper);

  // Initialize lightGallery after the gallery items are rendered
  lightGallery(document.getElementById('lightgallery'), {
    licenseKey: 'CEDD7394-A2D6-47B3-A995-C67CE95A34C6',
    selector: '.gallery-item',
  });

});

/** Load Events */
jQuery(function ($) {
  Alpine.plugin(collapse);
  Alpine.plugin(focus);
  Alpine.start();
  window.Alpine = Alpine;

  $(document).ready(function ($) {

    function getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };
    var category = getUrlParameter('category');
    if (category) {
      var $container = $('#filter-container');
      var $cards = $container.children('.card');

      $cards.sort(function (a, b) {
        var aId = parseInt($(a).attr('id').split('-')[1]);
        var bId = parseInt($(b).attr('id').split('-')[1]);
        return aId - bId;
      });
      $cards.detach().appendTo($container);
    }
    ;


    var sayings = $('.saying');

    function showSaying(index) {
      var saying = $(sayings[index]);
      var span = saying.find('span');

      span.css('opacity', '0');

      // Fade in the text and animate the letter spacing
      span.animate({opacity: 1}, 1000, function () {
      });

      // Keep the text visible for 2 seconds
      setTimeout(function () {
        // Fade out the text
        span.animate({opacity: 0}, 1000, function () {
          span.css('letter-spacing', '0em');
        });
        // Hide the text container after fade out
        setTimeout(function () {
          // Move to the next saying
          var nextIndex = (index + 1) % sayings.length;
          showSaying(nextIndex);
        }, 1000); // Delay to allow fade-out transition
      }, 10000); // Keep the text visible for 10 seconds
    }

    // Start the animation
    showSaying(0);
    // Background Image from the Nav Animation
    $('#nav-panel').mousemove(function (e) {
      var amountMovedX = (e.pageX * -1 / 80);
      var amountMovedY = (e.pageY * -1 / 80);
      $(this).css('background-position', amountMovedX + 'px ' + amountMovedY + 'px');
    });

    // Wave Animation
    function updateWavePaths(container) {
      var path1 = "M0 15 Q 5 10, 10 15 T 20 15 Q 25 20, 30 15 T 40 15 Q 45 10, 50 15 T 60 15 Q 65 20, 70 15 T 80 15 Q 85 10, 90 15 T 100 15";
      var path2 = "M0 10 Q 5 5, 10 10 T 20 10 Q 25 15, 30 10 T 40 10 Q 45 5, 50 10 T 60 10 Q 65 15, 70 10 T 80 10 Q 85 5, 90 10 T 100 10";
      var path3 = "M0 20 Q 5 15, 10 20 T 20 20 Q 25 25, 30 20 T 40 20 Q 45 15, 50 20 T 60 20 Q 65 25, 70 20 T 80 20 Q 85 15, 90 20 T 100 20";
      container.find('.wave-path').attr('d', path1);
      container.find('.wave-path2').attr('d', path2);
      container.find('.wave-path3').attr('d', path3);
    }

    $('.wave-container').each(function () {
      updateWavePaths($(this));
    });
  });
});

